import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "./api/apiSlice";
import themeReducer from "./features/theme/themeSlice";
import coursesReducer from "./features/courses/coursesSlice";
import authReducer from "./features/auth/authSlice";
import libraryReducer from "./features/library/librarySlice";
import accessReducer from "./features/access/accessSlice";
import dashboardReducer from "./features/dashboard/dashboardSlice";
import rewardsReducer from "./features/rewards/rewardsSlice";

import alertReducer from "./features/alert/alertSlice";

// Import API slices to ensure they're registered
import "./features/books/bookApiSlice";
import "./features/time-trails/timeTrailsApiSlice";

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage";

const reducers = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  library: libraryReducer,
  alert: alertReducer,
  courses: coursesReducer,
  theme: themeReducer,
  access: accessReducer,
  dashboard: dashboardReducer,
  rewards: rewardsReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware),

  devTools: process.env.REACT_APP_CLIENT_ENV === "development",
});

// Required for refetchOnFocus / refetchOnReconnect on opted-in queries only.
setupListeners(store.dispatch);

export const persistor = persistStore(store);